<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        products?: Product['id'][]
    }>(),
    {
        products: () => []
    }
)

const emit = defineEmits<{
    (_e: 'update:products', _products: Product['id'][]): void
}>()

/**
 * Use metadata.
 */
const { meta } = useMeta()

/**
 * Toggle a given product.
 */
function toggleProduct(productId: number) {
    if (props.products.includes(productId)) {
        emit(
            'update:products',
            props.products.filter(id => id !== productId)
        )
    } else {
        emit('update:products', [...props.products, productId])
    }
}
</script>

<template>
    <div>
        <div
            class="mx-auto flex max-w-screen-lg flex-wrap items-center justify-center gap-2 text-xs lg:text-base"
        >
            <button
                type="button"
                class="ease flex cursor-pointer items-center gap-2 border px-2 py-1 text-center transition-colors duration-200 hover:bg-sun-yellow"
                :class="[
                    !products.length
                        ? 'border-sun-yellow bg-sun-yellow'
                        : 'border-black'
                ]"
                @click="emit('update:products', [])"
            >
                <span>TOTAL</span>
            </button>
            <button
                v-for="product of meta.products"
                :key="product.id"
                type="button"
                class="ease group flex cursor-pointer items-center gap-2 border px-2 py-1 text-center transition-colors duration-200"
                :class="[
                    products.includes(product.id)
                        ? 'border-sun-yellow  bg-sun-yellow'
                        : 'border-black hover:bg-sun-yellow '
                ]"
                @click="toggleProduct(product.id)"
            >
                <div
                    class="h-4 w-4 rounded-full p-0.5 lg:h-6 lg:w-6 lg:p-1.5"
                    :style="{ backgroundColor: product.color }"
                >
                    <img
                        :alt="product.name"
                        :src="product.icon"
                        class="brightness-0 invert"
                    />
                </div>

                <span>{{ product.name }}</span>
            </button>
        </div>
    </div>
</template>